<template>
  <div class="tagging">
    <options/>
    <router-view/>
  </div>
</template>

<script>
import Options from "views/customer/childComps/tagging/Options";

export default {
  name: "Tagging",
  components: {
    Options
  }
}
</script>

<style scoped>
.tagging {
  background: rgb(245,246,250);
}
</style>